import type {ColorName} from '../colors/colors';

export const RANKED_COLORS: ColorName[] = [
    'reportOrange',
    'yellow',
    'green',
    'dotcomTeal',
    'navy',
    'blue',
    'focusBlue',
    'plum',
    'sidebarPrimary',
    'sidebarHovered',
];

export const STATE_NAMES: {
    [key: string]: string;
} = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virgina',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
};

// Reverses the STATE_NAMES object to be keyed by state name with the id as the value
export const STATE_IDS: {
    [key: string]: string;
    // @ts-expect-error
} = Object.fromEntries(
    Object.entries(STATE_NAMES).map(([id, name]: [string, string]) => [
        typeof name === 'string' ? name : '', // Flow doesn't understand this will always be a string
        id,
    ])
);
